import React from 'react';
import Fade from 'react-reveal/Fade';
import Button from 'elements/Button';

export default function Categories({ data }) {
    if (!Array.isArray(data) || data.length === 0) return null;

    return (
        <>
            <section className="container">
                <div className="row text-center justify-content-center mt-5" style={{ color: "#696969", borderTop: "2px solid rgba(105, 105, 105, 0.5)" }}>
                    <div className="my-5" style={{ color: "#333333" }}>
                        <h1>Temukan Produk Kami</h1>
                        <p className="lead mt-4 px-3" style={{ fontSize: "1.1rem" }}>
                            Rasakan kenyamanan luar biasa di Villa dan Venue Event kami di Cipanas, Puncak Bogor. Tempat yang sempurna untuk liburan yang tenang atau acara spesial yang tak terlupakan, dikelilingi pemandangan indah yang menenangkan.
                        </p>
                    </div>
                </div>
            </section>

            <section className="container categories-products mb-5" style={{ color: "#333333" }}>
                {data.map((category, index1) => {
                // Jangan render kategori jika itemId tidak ada atau kosong
                if (!Array.isArray(category.itemId) || category.itemId.length === 0) {
                    return null;
                }

                return (
                    <div key={`category-${index1}`}>
                    <Fade bottom>
                        <h4 className="mb-3 mt-5 fw-medium">{category.name}</h4>
                        <div className="row g-4">

                        {/* ✅ Tambahkan baris ini */}
                        {(() => {
                            const sortedItems = [...category.itemId].sort(
                            (a, b) => (b.isPopular === "true") - (a.isPopular === "true")
                            );
                            return sortedItems.map((item, index2) => (
                            <div
                                className="item col-12 col-lg-4"
                                key={`category-${index1}-item-${index2}`}
                            >
                                <Fade bottom delay={300 * index2}>
                                <div className="card">
                                    {item.isPopular === "true" && (
                                    <div className="tag">
                                        Popular <span className="fw-light">Choice</span>
                                    </div>
                                    )}
                                    <figure className="img-wrapper" style={{ height: 240 }}>
                                    <img
                                        src={
                                        item.imageId && item.imageId[0]
                                            ? `${process.env.REACT_APP_HOST}/images/${item.imageId[0].imageUrl}`
                                            : "/path/to/placeholder/image.jpg"
                                        }
                                        alt={item.title || "No title available"}
                                        className="img-cover"
                                    />
                                    </figure>
                                    <div className="meta-wrapper">
                                    <Button
                                        type="link"
                                        href={`/properties/${item._id}`}
                                        className="stretched-link d-block text-gray-800 text-black text-decoration-none"
                                    >
                                        <h5 className="h4" style={{ color: "#696969" }}>
                                        {item.title}
                                        </h5>
                                    </Button>
                                    <span className="text-grap-500" style={{ color: "#333333" }}>
                                        {item.city}, {item.country}
                                    </span>
                                    </div>
                                </div>
                                </Fade>
                            </div>
                            ));
                        })()}

                        </div>
                    </Fade>
                    </div>
                );
                })}

            </section>
        </>
    );
}
